<template>
    <label :for="inputId">
        <CardSelectableItem
            :alignContent
            :autoFocus
            :error
            :formControlPosition
            :helperText
            :label
            :selected="!!model"
        >
            <template #formControl>
                <DsCheckbox
                    v-model="model"
                    :inputId
                    :name
                    noLabelWrapper
                    :value
                />
            </template>
            <slot v-if="$slots.default" />
        </CardSelectableItem>
    </label>
</template>

<script setup lang="ts">
import type { CardSelectableItemProps } from '@/components/design-system/form/input/CardSelectableItem.vue';
import { useId } from 'vue';
import CardSelectableItem from './CardSelectableItem.vue';
import DsCheckbox from './DsCheckbox.vue';

export interface DsCardCheckboxProps {
    label?: string;
    helperText?: string;
    name: HTMLInputElement['name'];
    value: HTMLInputElement['value'];
    alignContent?: CardSelectableItemProps['alignContent'];
    error?: string | boolean;
    autoFocus?: boolean;
    formControlPosition?: CardSelectableItemProps['formControlPosition'];
    inputId?: HTMLInputElement['id'];
}

const props = withDefaults(defineProps<DsCardCheckboxProps>(), {
    alignContent: 'center',
    error: false,
    autoFocus: false,
    formControlPosition: 'left',
});

const inputId = props.inputId ?? useId();

const model = defineModel();

defineSlots<{
    default: () => void;
}>();
</script>
